import { useState, useEffect, useCallback } from "react";
import { ChevronDown } from "lucide-react";
import { cn, Image, Input, Select } from "@heroui/react";
import { ButtonOverride as Button } from "@/components/Buttons/ButtonOverride";
import type { TokenConfigType } from "@/constants/types/currency";
import { debounce } from "lodash";
import type { NativeTokenPrices } from "@/constants/project-specific/farms/types";
import { chainSettings, fallbackChainId, type ChainType } from "@/constants/chain-specific";
type WalletInputProps = {
  type: "Wallet" | string;
  onSelectClick?: () => void;
  selectedToken?: TokenConfigType;
  value?: string;
  balance?: number;
  onChange?: (value: string) => void;
  nativePrices?: NativeTokenPrices;
  tokenPrices?: Record<string, number>;
  chainId: ChainType;
};
export default function WalletInput({
  type = "Wallet",
  onSelectClick,
  selectedToken,
  value,
  onChange,
  balance,
  nativePrices,
  chainId,
  tokenPrices
}: WalletInputProps) {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>(value || "");

  // Debounced onChange handler
  const debouncedOnChange = useCallback(debounce((value_0: string) => {
    if (onChange) {
      onChange(value_0);
    }
  }, 500),
  // Adjust the debounce delay as needed
  [onChange]);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      value: value_1
    } = event.target;
    setInputValue(value_1);
    debouncedOnChange(value_1);
  };
  return <div className={`cards-farm p-4 rounded-lg border-2 transition-colors bg-slate-900/85 w-full ${isFocused ? "border-input" : "border-primary"}`}>
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-md font-medium">{type}</h2>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex space-x-2">
          <div className="flex-grow">
            <Input type="string" isClearable variant="flat" color="primary" placeholder="0x..." value={value && value} onChange={handleChange} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} className="w-full" classNames={{
            label: "text-black/50 dark:text-white/90",
            input: ["", "text-md text-white/90", "placeholder:text-white/60"],
            innerWrapper: "bg-transparent ",
            inputWrapper: ["bg-transparent", "bg-transparent", "backdrop-blur-xl", "hover:bg-transparent", "dark:hover:bg-transparent", "group-data-[focus=true]:bg-transparent", "dark:group-data-[focus=true]:bg-transparent", "!cursor-text"]
          }} />
          </div>
        </div>
      </div>
    </div>;
}